
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';
import HeaderComponent from '../table/header/headerComponent';
import LeadTimeAction from '../../app/store/actions/leadTime';

class LeadTimeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        id: '',
        distributionCenterCode: '',
        storeBranchCode: '',
        transferLeadTimeDays: '',
      },
      message: '',
      success: '',
    };
  }

  async componentDidMount() {
    const { rowData } = this.props.location;
    if (rowData) {
      await this.setClientUpdate(rowData);
    }
  }

  setClientUpdate = async (item) => {
    if (item) {
      const { form } = this.state;
      form.id = item.id;
      form.distributionCenterCode = item.distributionCenterCode;
      form.storeBranchCode = item.storeBranchCode;
      form.transferLeadTimeDays = item.transferLeadTimeDays;

      this.setState({
        message: '',
        success: '',
        form,
      });
    }
  };

  goBack = () => history.push({
    pathname: ROUTES.PARAMETERS,
  });

  createLeadTime = async () => {
    const { form } = this.state;
    form.userCreated = this.props.user.id;

    try {
      await this.props.createLeadTime(form);
      this.setState({
        message: '',
        success: I18n.t('leadTimeCreated'),
        form: {
          id: '',
          distributionCenterCode: '',
          storeBranchCode: '',
          transferLeadTimeDays: '',
        },
      });
      this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.code === 1619) {
        const messageError = I18n.t('leadTimeAlreadyRegistered');
        this.setState({ message: messageError });
      } else {
        this.setState({ message: I18n.t('errorOcurred') });
      }
      this.setState({ form });
    }
  };

  updateLeadTime = async () => {
    const { form } = this.state;
    form.userEdited = this.props.user.id;
    await this.props.updateLeadTime(form);

    this.setState({ message: '', success: I18n.t('updatedLeadTime') });
  };

  result = async (selected) => {
    const { form } = this.state;
    form.codeDeposit = selected;
    this.setState({ form });
  };

  render() {
    const { form, message, success } = this.state;
    const {
      id, distributionCenterCode, storeBranchCode, transferLeadTimeDays,
    } = form;

    return (
      <div className="main-table">
        <HeaderComponent title={I18n.t('leadTimeRegister')} />

        <div className="form-group">
          <div className="form-group">
            <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
              <Translate value="distributionCenterCode" />
            </p>
            <input
              type="text"
              className="form-control"
              name="distributionCenterCode"
              value={distributionCenterCode}
              onChange={(e) => {
                const { form: currentForm } = this.state;
                currentForm.distributionCenterCode = e.target.value;
                this.setState({ form: currentForm });
              }}
            />
          </div>
          <div className="form-group">
            <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
              <Translate value="storeBranchCode" />
            </p>
            <input
              type="text"
              className="form-control"
              name="storeBranchCode"
              value={storeBranchCode}
              onChange={(e) => {
                const { form: currentForm } = this.state;
                currentForm.storeBranchCode = e.target.value;
                this.setState({ form: currentForm });
              }}
            />
          </div>
          <div className="form-group">
            <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
              <Translate value="transferLeadTimeDays" />
            </p>
            <input
              type="number"
              className="form-control"
              name="transferLeadTimeDays"
              value={transferLeadTimeDays}
              onChange={(e) => {
                const { form: currentForm } = this.state;
                currentForm.transferLeadTimeDays = e.target.value;
                this.setState({ form: currentForm });
              }}
            />
          </div>

          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id ? (
            <button
              type="button"
              className="btn btn-dark margin"
              onClick={this.updateLeadTime}
            >
              <Translate value="update" />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-dark"
              onClick={this.createLeadTime}
            >
              <Translate value="register" />
            </button>
          )}
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateLeadTime: leadTime => dispatch(LeadTimeAction.updateLeadTime(leadTime)),
  createLeadTime: leadTime => dispatch(LeadTimeAction.createLeadTime(leadTime)),
});

const mapStateToProps = state => ({
  leadTime: state.leadTime && state.leadTime.leadTime,
  user: state.auth && state.auth.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadTimeForm);
